import { doc, getDoc, setDoc, arrayRemove } from 'firebase/firestore';
import { firestore } from 'src/config/firebaseClient';

export const removeWalletAddress = async (userId: string, address: string) => {
  const userRef = doc(firestore, `User/${userId}`);
  const userDoc = await getDoc(userRef);

  if (userDoc.exists()) {
    const userAddresses = userDoc.data()?.addresses;

    if (!userAddresses || !userAddresses.includes(address)) {
      throw new Error('Address not found in the user document');
    }

    await setDoc(
      userRef,
      {
        addresses: arrayRemove(address),
      },
      { merge: true },
    );
  } else {
    throw new Error('User not found');
  }
};
